import React, { useState, useEffect } from 'react'
import { Box, Heading, Text, Button, FormControl, Input, Stack, ResponsiveStack } from '@/components/lib'
import api from '../../api'
import useStore from '../../store'
import utils from '../../utils/utils.js'

function TeamIntegrations () {
  const [loading, setLoading] = useState(false)
  const [nutriticsUsername, setNutriticsUsername] = useState('')
  const [nutriticsPassword, setNutriticsPassword] = useState('')
  const { user, team, updateTeam } = useStore()

  useEffect(() => {
    if (team) {
      setNutriticsUsername(team.services?.nutritics?.username || '')
      setNutriticsPassword(team.services?.nutritics?.password || '')
    }
  }, [team])

  function updateNutriticsDetails () {
    setLoading(true)
    api.teams.updateNutriticsDetails(team._id, { username: nutriticsUsername, password: nutriticsPassword }, newDetails => {
      utils.toast('success', 'Details updated')
      setLoading(false)
      const newTeam = Object.assign({}, team, { services: { nutritics: newDetails } })
      updateTeam(newTeam)
    }, err => {
      utils.toast('error', 'Unable to update details', err.message)
      setLoading(false)
    })
  }

  return (
    <Stack gap={5}>
      {utils.hasPermission(user, 'team.manage', team?._id)
        ? (
          <Stack gap={3} p={3} rounded='md' borderWidth='1px'>
            <Box>
              <Heading as='h3' size='md'>Nutritics</Heading>
              <Text color='fg.muted'>Trialflare can use Nutritics as a database source when using the "Food" data type in a trial. If your organisation already possesses a Nutritics license, you can use your own credentials here. Alternatively, you can subscribe to a Trialflare plan that includes Nutritics access.</Text>
            </Box>

            <ResponsiveStack>
              <FormControl label='Nutritics username'>
                <Input type='email' value={nutriticsUsername} onChange={e => setNutriticsUsername(e.target.value)} />
              </FormControl>

              <FormControl label='Nutritics password'>
                <Input type='password' value={nutriticsPassword} onChange={e => setNutriticsPassword(e.target.value)} />
              </FormControl>
            </ResponsiveStack>
            <Box>
              <Button loading={loading} onClick={updateNutriticsDetails} colorPalette='primary'>Save Nutritics details</Button>
            </Box>
          </Stack>)
        : (
          <Box>
            <Heading>Page unavailable</Heading>
            <Text>This page is only viewable by users that manage the team</Text>
          </Box>)}
    </Stack>
  )
}

export default TeamIntegrations
